import { useEffect, useState, useRef } from 'react';
import ICONS from 'utils/icons';
import { truncateText } from 'utils/helper';
import { getClassNameByLang } from 'utils/getClassByLang';
import { SubHeading, TextBody } from 'components/Typography/General';
import { isMobile } from 'react-device-detect';
import { getDirectionByLanguage } from 'utils/get_direction';

const Collapsible = (props) => {
  const { chevronDown, chevronUp } = ICONS;
  const { title, description, isOpen, changeModal, language } = props;

  const classNameByLang = getClassNameByLang(language);

  const [position, setPosition] = useState(0);
  const itemRef = useRef(null);

  useEffect(() => {
    setPosition(itemRef.current?.getBoundingClientRect().top + window.scrollY - 110);

    return () => {
      setPosition(0);
      itemRef.current = null;
    };
  }, []);

  return (
    <div
      className="collapsible"
      ref={itemRef}
      onClick={() => {
        changeModal(title);
        if (!isOpen) {
          window.scrollTo({
            behavior: 'instant',
            top: position,
          });
        }
      }}
    >
      <div className="collapsible__title" style={{ textWrap: 'break-word' }}>
        <SubHeading variety={isMobile ? 3 : 4} className="title-3">
          {title}
        </SubHeading>
        <img src={isOpen ? chevronUp : chevronDown} alt="chevronDown" />
      </div>
      {isOpen && (
        <TextBody
          variety={4}
          dir={getDirectionByLanguage(language)}
          className={`collapsible__description ${classNameByLang}`}
          style={{ textWrap: 'break-word', lineHeight: '1.5' }}
          dangerouslySetInnerHTML={{ __html: description }}
        ></TextBody>
      )}
    </div>
  );
};

export default Collapsible;
